import { createSlice } from "@reduxjs/toolkit";
import {
  approveTaskRequestChange,
  generatePresignedURL,
  getAllReportees,
  getAllTaskboxItems,
} from "./thunk";

const initialState = {
  getAllTaskboxResponse: null,
  getAllTaskboxResponseStatus: null,

  approveTaskRequestChangeResponse: null,
  approveTaskRequestChangeResponseStatus: null,

  generatePresignedURLResponse: null,
  generatePresignedURLResponseStatus: null,

  getAllReporteesResponse: null,
  getAllReporteesResponseStatus: null,

  loading: false,
  separationEmpData: "",
  totalTaskLength: 0,
};

const taskboxSlice = createSlice({
  name: "taskbox",
  initialState: initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSeparationEmpData: (state, action) => {
      state.separationEmpData = action.payload;
    },
    resetApproveTaskRequestChange: (state, action) => {
      state.approveTaskRequestChangeResponse = null;
      state.approveTaskRequestChangeResponseStatus = null;
    },
    settotalTaskLength: (state, action) => {
      state.totalTaskLength = action.payload;
    },
    setInitialState: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllTaskboxItems.pending, (state, action) => {
      state.getAllTaskboxResponse = null;
      state.getAllTaskboxResponseStatus = "PENDING";
    });
    builder.addCase(getAllTaskboxItems.rejected, (state, action) => {
      state.getAllTaskboxResponse = action.payload;
      state.getAllTaskboxResponseStatus = "ERROR";
    });
    builder.addCase(getAllTaskboxItems.fulfilled, (state, action) => {
      state.getAllTaskboxResponse = action.payload;
      state.getAllTaskboxResponseStatus = "SUCCESS";
    });

    builder.addCase(approveTaskRequestChange.pending, (state, action) => {
      state.approveTaskRequestChangeResponse = null;
      state.approveTaskRequestChangeResponseStatus = "PENDING";
    });
    builder.addCase(approveTaskRequestChange.rejected, (state, action) => {
      state.approveTaskRequestChangeResponse = action.payload;
      state.approveTaskRequestChangeResponseStatus = "ERROR";
    });
    builder.addCase(approveTaskRequestChange.fulfilled, (state, action) => {
      state.approveTaskRequestChangeResponse = action.payload;
      state.approveTaskRequestChangeResponseStatus = "SUCCESS";
    });

    builder.addCase(generatePresignedURL.pending, (state, action) => {
      state.generatePresignedURLResponse = null;
      state.generatePresignedURLResponseStatus = "PENDING";
    });
    builder.addCase(generatePresignedURL.rejected, (state, action) => {
      state.generatePresignedURLResponse = action.payload;
      state.generatePresignedURLResponseStatus = "ERROR";
    });
    builder.addCase(generatePresignedURL.fulfilled, (state, action) => {
      state.generatePresignedURLResponse = action.payload;
      state.generatePresignedURLResponseStatus = "SUCCESS";
    });

    builder.addCase(getAllReportees.pending, (state, action) => {
      state.getAllReporteesResponse = null;
      state.getAllReporteesResponseStatus = "PENDING";
    });
    builder.addCase(getAllReportees.rejected, (state, action) => {
      state.getAllReporteesResponse = action.payload;
      state.getAllReporteesResponseStatus = "ERROR";
    });
    builder.addCase(getAllReportees.fulfilled, (state, action) => {
      state.getAllReporteesResponse = action.payload;
      state.getAllReporteesResponseStatus = "SUCCESS";
    });
  },
});

export const taskboxActions = taskboxSlice.actions;

export default taskboxSlice.reducer;
